import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { s360ConfigService } from "../../Services/S360Config";
import HWUser from "../../HWLibrary/HWUser";

class CloseMessage extends Component {
  showMessageTime = () => {
    return this.props.message.type !== MessageType.info;
  };

  componentDidMount() {
    localStorage.removeItem("agentConnected")
    localStorage.removeItem("agentWaiting");
    window.parent.postMessage(
      {
        agentConnected: 'false',
      },
      "*"
    )
  }

  componentWillUnmount() {
    if (s360ConfigService?.config?.hideIcon) {
      localStorage.removeItem("isLoggedIn");
    }
    localStorage.removeItem("agentConnected");
    localStorage.removeItem("agentWaiting");
    window.parent.postMessage(
      {
        agentConnected: 'false',
      },
      "*"
    )
  }

  messageTimeClassName = () => {
    switch (this.props.message.type) {
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  messageBoxClassName = () => {
    switch (this.props.message.type) {
      case MessageType.info:
        return "s360-message-box-info";
      default:
        return "";
    }
  };

  messageContainerClassName = () => {
    switch (this.props.message.type) {
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.info:
        return {
          paddingTop: "10px",
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageCloseTextFontColor,
        };
      default:
        return {};
    }
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    switch (this.props.message.type) {
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      default:
        return {};
    }
  };

  onMouseEnter = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    const designDetails = this.props.config.designDetails;
    e.target.style.color = isNullOrUndefined(
      designDetails.buttonHighlightTextColor
    )
      ? "white"
      : designDetails.buttonHighlightTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonHighlightBackgroundColor
    )
      ? "rgb(3, 19, 122)"
      : designDetails.buttonHighlightBackgroundColor;
  };

  onMouseLeave = (e) => {
    if (!e.target) {
      return;
    }
    // if (e.target.disabled === true) { return }
    const designDetails = this.props.config.designDetails;
    e.target.style.color = isNullOrUndefined(designDetails.buttonTextColor)
      ? "rgb(3, 19, 122)"
      : designDetails.buttonTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonBackgroundColor
    )
      ? "white"
      : designDetails.buttonBackgroundColor;
  };

  newConversationTextStyle = () => {
    const designDetails = this.props.config.designDetails;
    return {
      // color: this.props.config.designDetails.selectionButtonsvgColor,
      fontFamily: this.props.config.designDetails.selectionButtonFont,
      fontSize: this.props.config.designDetails.selectionButtonFontSize + "px",
      // background: this.props.config.designDetails.selectionButtonBkgColor

      color: isNullOrUndefined(designDetails.buttonTextColor)
        ? "rgb(3, 19, 122)"
        : designDetails.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetails.buttonBackgroundColor)
        ? "white"
        : designDetails.buttonBackgroundColor,
      border: "1px solid rgb(3, 19, 122)",
    };
  };

  render() {
    let isManualSessionActionEnabled =
      this.props.config &&
      this.props.config.configDetails &&
      this.props.config.configDetails.allowManualSessionEnd === true;
    console.log(
      this.props.config.configDetails.allowManualSessionEnd,
      "here checking for reset button"
    );
    return (
      <div
        className={
          localStorage.getItem("openInFullScreen")
            ? "s360-closeConversation-close-container-fs"
            : "s360-closeConversation-close-container"
        }
      >
        <div
          className={
            localStorage.getItem("openInFullScreen")
              ? "s360-close-conversation-text-fs"
              : "s360-close-conversation-text"
          }
        >
          <p>
            {s360ConfigService.config?.configDetails?.sessionCloseMessage?.toString()}
          </p>
        </div>
        <div
          className={
            localStorage.getItem("openInFullScreen")
              ? "s360-close-conversation-button-fs"
              : "s360-close-conversation-button"
          }
        >
          <button
            onClick={this.props.startNewConversation}
            style={{
              background: isNullOrUndefined(
                this.props.config.designDetails
                  .closeConversationButtonBackGround
              )
                ? "linear-gradient(124deg, rgb(0 90 255) 0%, rgb(18 24 164) 54%, rgb(14 86 197) 100%, rgb(0, 212, 255) 100%)"
                : this.props.config.designDetails
                    .closeConversationButtonBackGround,
            }}
          >
            Start New Conversation
          </button>
        </div>
        {/* <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    <strong>{this.props.message.message.text}</strong>
                    <br />
                </div>
                {this.showMessageTime() && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.message.message.sentTimestamp).format("DD MMM h:mm a")}</div>}
            </div>

            { this.props.config.newConversation ? <div className="s360-close-conversation-start">
                   <div  className="s360-close-conversation-start-btn" style={this.newConversationTextStyle()} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}   onClick={this.props.startNewConversation}> New Conversation </div> */}
        {/* </div> : null } */}
      </div>
    );
  }
}

export default CloseMessage;
